// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import OverseasHotel from '../_raw/service/icon_overseas_hotel.svg';
import withIconProps from '../withIconProps';

export default withIconProps(OverseasHotel);
